import { AddBoxOutlined } from "@mui/icons-material";
import { Box, Button, Divider, Grid } from "@mui/material";
import { BodyText, CustomChip, SubTitleText, TravelPlan } from "Application/components";
import { useCreatePlanStore } from "Application/store";
import { FC } from "react";

interface PlansProps {
    addPlanDialog: () => void;
}

export const Plans: FC<PlansProps> = ({addPlanDialog}) => {
    const { fetchedPlans } = useCreatePlanStore();
    const plansCount = fetchedPlans.length;

    return (
        <Box className="border rounded-xl shadow-sm border-slate-200 p-6">
            <Box className="flex flex-wrap justify-between items-center" id="header-section">
                <Box className="flex flex-col space-y-2" id="title-section">
                    <Box className="flex items-end space-x-2">
                        <SubTitleText text={'Plans'} />
                        <CustomChip text={`${plansCount} plans`} />
                    </Box>
                    <BodyText text={'Manage your product plans'} />
                </Box>
                <Button
                    onClick={addPlanDialog}
                    className="text-sky-700 border-sky-200 bg-sky-50 rounded-md mt-2 md:mt-0"
                    variant="outlined"
                    startIcon={<AddBoxOutlined />}
                >
                    Add New Plan
                </Button>
            </Box>
            <Divider className="my-6" />
            <Grid container spacing={4}>
                <Grid item sx={{ width: 1 }}>
                    <TravelPlan data={fetchedPlans} />
                </Grid>
            </Grid>
        </Box>
    )
}